// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  margin-top: 20px;
}

.chart-container {
  position: relative;
  margin: 0 auto;
  width: 80%;
}

.canvas-container {
  max-width: 500px;
  margin: 0 auto;
}

.canvas-container canvas {
  width: 100% !important;
  height: auto !important;
}

.summary-card {
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);
  transition: transform 0.3s;
  cursor: pointer;
}

.summary-card:hover {
  transform: translateY(-5px);
}

.card-icon {
  font-size: 2rem;
  color: #fff;
  padding: 0.5rem;
  border-radius: 50%;
  background-color: #28a745;
  width: 50px;
  height: 50px;
}

.btn-download {
  background: #0060d6;
}
.btn-download:hover {
  background-color: #1a1a86;
}

.btn-outline-submit {
  color: #1a1a86;
  background: transparent;
  border-color: #1a1a86;
}
.btn-outline-submit:hover {
  color: white;
  background: #1a1a86;
}

.form-select {
  border-color: #1a1a86;
}

.card-title {
  font-size: 18px;
  color: rgb(72, 71, 71);
}

.title {
  color: rgb(104, 104, 104);
}

.dashboard-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.card {
  flex: 1;
  min-width: 280px;
  padding: 16px;
  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);
  border-radius: 8px;
  background-color: #fff;
}

.card h2 {
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 16px;
}

#aptsiTable {
  overflow-y: auto;
  height: 400px;
}

.report-container {
  height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/features/ada-access/reports/aac-reports.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,UAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,sBAAA;EACA,uBAAA;AACF;;AAGA;EACE,qBAAA;EACA,2CAAA;EACA,0BAAA;EACA,eAAA;AAAF;;AAEA;EACE,2BAAA;AACF;;AACA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAEF;;AAGE;EACE,mBAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;;AAIE;EACA,cAAA;EACA,uBAAA;EACA,qBAAA;AADF;AAGE;EACE,YAAA;EACA,mBAAA;AADJ;;AAME;EACE,qBAAA;AAHJ;;AAMA;EACE,eAAA;EACA,sBAAA;AAHF;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAHF;;AAMA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,2CAAA;EACA,kBAAA;EACA,sBAAA;AAHF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,aAAA;AAJF;;AAOA;EACE,YAAA;AAJF","sourcesContent":[":host {\n  display: block;\n  margin-top: 20px;\n}\n\n.chart-container {\n  position: relative;\n  margin: 0 auto;\n  width: 80%;\n}\n\n.canvas-container {\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.canvas-container canvas {\n  width: 100% !important;\n  height: auto !important;\n}\n\n\n.summary-card {\n  border-radius: 0.5rem;\n  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);\n  transition: transform 0.3s;\n  cursor: pointer;\n}\n.summary-card:hover {\n  transform: translateY(-5px);\n}\n.card-icon {\n  font-size: 2rem;\n  color: #fff;\n  padding: 0.5rem;\n  border-radius: 50%;\n  background-color:  #28a745;\n  width: 50px;\n  height: 50px;\n  \n}\n\n\n  .btn-download{\n    background: #0060d6; \n\n    &:hover{\n      background-color:  #1a1a86;\n    }\n  }\n\n  .btn-outline-submit{\n  color: #1a1a86;                 // text / border color\n  background: transparent;\n  border-color: #1a1a86;\n\n  &:hover{\n    color: white;\n    background: #1a1a86;\n\n  }\n  }\n\n  .form-select{\n    border-color: #1a1a86;\n  }\n\n.card-title{\n  font-size: 18px;\n  color: rgb(72, 71, 71);\n}\n\n.title{\n  color: rgb(104, 104, 104);\n}\n\n.dashboard-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.card {\n  flex: 1;\n  min-width: 280px;\n  padding: 16px;\n  box-shadow: 0 4px 6px rgba(2, 56, 121, 0.5);\n  border-radius: 8px;\n  background-color: #fff;\n  \n}\n\n.card h2 {\n  font-size: 1.25rem;\n  font-weight: 500;\n  margin-bottom: 16px;\n}\n\n#aptsiTable{\n  overflow-y: auto;\n  height: 400px;\n}\n\n.report-container{\n  height: 50px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
